import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import userReducer from "./user/userSlice";
import postSlice from "./post/postSlice";
import funModeReducer from "./fun-mode/funModeSlice";

// import { persistReducer, persistStore } from "redux-persist";
// import storage from "redux-persist/lib/storage";
//need to move all the custome persist config in seperate file
// const persistConfig = {
//   key: "root",
//   storage,
//   blocklist: ["user"],
// };
//persistConfig -> is the root persisi config
//authPersistConfig -> is the persist config for authSlice only.we can
//add more fields in safelist or in blocklist array according to need
//safelist array -> fields of state which we want to persist
//blocklist array ->fields which we don,t want to persist

// const authPersistConfig = {
//   key: "auth",
//   storage,
//   safelist: ["loggedInUser"],
// };

const rootReducer = combineReducers({
  // auth: persistReducer(authPersistConfig, authReducer),
  auth: authReducer,
  user: userReducer,
  post: postSlice,
  funMode: funModeReducer,
});

// const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  reducer: rootReducer,
});
// export const persistedStore = persistStore(store);
